<template>
  <family-page-wrapper class="family-receipts">
    <div class="row">
      <div class="col-12">
        <pull-up-receipt />
      </div>
    </div>
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const PullUpReceipt = defineAsyncComponent(() => import('@/components/Main/Operator/Receipts/PullUpReceipt.vue') as any);
</script>
